import { Component, ChangeDetectorRef } from '@angular/core'
import { IonicPage, LoadingController, NavController, NavParams, ToastController, ViewController } from 'ionic-angular'
import { Events } from 'ionic-angular'

import { HousingUnit, DeviceCache, DomainEvents, SignalingMessage } from '../../models/models'
import { CallPage } from '../call/call'
import { MessageCreateIntercomPage } from '../message-create-intercom/message-create-intercom'
import { DeviceProvider } from '../../providers/device/device'
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit'
import { LoginPage } from '../login/login'
import { AuthProvider } from '../../providers/auth/auth'
import { CondominiumIntercomPage } from '../condominium-intercom/condominium-intercom'
import { MessageCreateAudioPage } from '../message-create-audio/message-create-audio'
import { SignalingSocketIoProvider } from '../../providers/signaling/socket_io'
import { ConfigProvider } from '../../providers/config/config'

@IonicPage()
@Component({
	selector: 'page-housing-unit-intercom',
	templateUrl: 'housing-unit-intercom.html',
})
export class HousingUnitIntercomPage {
	private dismissTimeout: number = null;

	private _housingUnit: HousingUnit
	public get housingUnit(): HousingUnit {
		return this._housingUnit
	};
	public set housingUnit(value: HousingUnit) {
		this._housingUnit = value
		//se attiva la aggiorna
		if(this.isChangeDetected)
			this.changeDetector.detectChanges()
	}

	private _isLoading: boolean = false;
	public get isLoading(): boolean {
		return this._isLoading
	};
	public set isLoading(value: boolean) {
		this._isLoading = value
		//se attiva la aggiorna
		if(this.isChangeDetected)
			this.changeDetector.detectChanges()
	}

	private loading: any

	/**
	se usare il video nella chiamata voip
	*/
	private voipIsVideo: boolean = true;
	/**
	id voip che si sta chiamando
	*/
	private voipOtherId: string = null;

	/**
	Timeout Pong per avviare la chiamata voip
	*/
	private voipPingTimeout: number = null;

	/**
	Timeout PONG scaduto: avvia la chiamata diretta
	*/
	private voipPingTimeoutHandler = () => {
		//NON ha ricevuto risposta in tempo utile (timeout scaduto prima di essere rimosso)

		//deregistra timer e pong listener
		this.clearPingPong()

		let self = this
		//chiama diretto
		this.callDirect().then(() => {
			console.debug('[HousingUnitIntercomPage.voipPingTimeoutHandler] Chiamata diretta avviata')
			//rimuove il loader presentato al ping
			self.clearLoading()
		}).catch(e => {
			console.error('Errore usando la chiamata diretta', e)
			self.showError('Impossibile avviare la chiamata in questo momento')
			self.navCtrl.pop()
		})
	}
	/**
	Gestore PONG per avviare la chiamata voip.

	Spegne il timeout chiamata vocale e avvia la chiamata VOIP
	*/
	private voipPongHandler = (pong: SignalingMessage) => {
		console.debug('[HousingUnitIntercomPage.voipPongHandler] PONG ricevuto')
		/**
		Se timer attivo lo ferma e chiama, altrimenti non fa nulla
		*/
		if(this.voipPingTimeout) {//timer attivo
			//Controllo che il PONG sia dall'utente chiamato
			if(pong.senderId != this.voipOtherId) {
				console.warn('[HousingUnitIntercomPage.voipPongHandler] Ricevuto PONG da un altro utente (chiamata precedente?), ignoro il pong', pong)
				return
			}
			this.clearPingPong()

			console.debug('[HousingUnitIntercomPage.voipPongHandler] PONG ricevuto in tempo, uso la vidoechiamata')
			this.callVoip()
		} else {
			console.debug('PONG ricevuto troppo tardi o ricevuto un secondo PONG, non avvio VOIP')
		}
	}

	private isChangeDetected: boolean = false;

	/**
	Flag per indicare che una chiamata è in corso
	*/
	private _isCalling: boolean = false;
	public get isCalling(): boolean {
		return this._isCalling
	};
	public set isCalling(value: boolean) {
		this._isCalling = value
		//se attiva la aggiorna
		if(this.isChangeDetected)
			this.changeDetector.detectChanges()
	}

	/**
	Verifica se si può lasciare un messaggio audio
	*/
	public get isAudioable(): boolean {
		return this.housingUnit.is_message_audio_enabled
	}
	/**
	Verifica se abbia un numero di telefono o un contatto per videochiamare
	*/
	public get isCallable(): boolean {
		return !!(this.housingUnit.intercom_phone || this.housingUnit.intercom_user_id)
	}
	public get isOpenable(): boolean {
		//apre da qui solo se ha apertura automatica o è unità abitativa singola, apertura proprietario per unità multiple è sotto pulsantiera citofono
		return this.housingUnit.is_auto_open_enabled || this.isSingleHousingUnit
	}
	public get isTextable(): boolean {
		return this.housingUnit.user_roles === undefined || (this.housingUnit.user_roles && this.housingUnit.user_roles.length > 0)
	}
	/**
	Visualizza pulsante invia video
	*/
	public get isVideoable(): boolean {
		return false
	}



	/**
	Restituisce il valore per il quale deve essere eseguito lo zoom delle icone
	*/
	public get buttonCount(): number {
		let z = 0//bottoni fake lascia messaggio audio e video
		if(this.isVideoable) {
			z++
		}
		if(this.isAudioable) {
			z++
		}
		if(this.isCallable) {
			z++
		}
		if(this.isTextable) {
			z++
		}
		if(this.isOpenable) {
			z++
		}
		return z
	}

	private isSingleHousingUnit: boolean = false;

        constructor(
                private auth: AuthProvider,
                private changeDetector: ChangeDetectorRef,
                private events: Events,
               public devices: DeviceProvider,
               private housingUnits: HousingUnitProvider,
               private loadingCtrl: LoadingController,
               public navCtrl: NavController,
		public navParams: NavParams,
		private signaling: SignalingSocketIoProvider,//per eseguire il ping pre-chiamata
		public toastCtrl: ToastController,
		private viewCtrl: ViewController
	) {
		//assegna l'unità abitativa senza forzare il refresh
		//NOTE Invocando changeDetector nelo costruttore perde la pagina dal top dello stack
		this._housingUnit = navParams.get('housingUnit')
		console.debug("[HousingUnitIntercomPage.constructor()] Aperta l'interfaccia di interazione cotofono per l'unità immibliare:", this.housingUnit)

		if(this.housingUnit && !this.housingUnit.user_roles) {
			console.warn('[HousingUnitIntercomPage.constructor()] Ricevuta unità abitativa senza ruoli utente')
		}
		this.isSingleHousingUnit = navParams.get('isSingleHousingUnit') ? true : false
	}

	/**
	Apre la pagina per registrare e inviare un messaggio audio
	*/
	public audio() {
		let self = this

		this.navCtrl.push(MessageCreateAudioPage, {
			housingUnit: this.housingUnit
		}).then(() => {//rimuove questa schermata dopo aver inserito l'altra
			let index = self.viewCtrl.index
			self.navCtrl.remove(index)
		})
	}

	/**
	Avvia la chiamata
	*/
	public call(video = true) {
		let self = this

		if(this.voipPingTimeout) {//Chiamata già avviata in attesa di risposta
			console.info('Chiamata già in attesa di iniziare, probabile doppio click, non eseguo una seconda richiesta')
		}
		if(this.isCalling) {//Chiamata già in corso
			console.warn("Chiamata già avviata, le UI non dovevano permettere di avviarne un'altra")
		}

		//salva il flag per chiamata video
		this.voipIsVideo = video

		/*
		DECIDE COME CHIAMARE: In funzione della disponibilità di chiamata diretta e VOIP
		*/
		if(!this.housingUnit.intercom_user_id) {//NO VOIP
			if(!this.housingUnit.intercom_phone) {//NO VOIP NO DIRECT
				console.error("[HousingUnitIntercomPage.call()] L'unità abitativa non dispone di un destinatario citofono configurato", this.housingUnit)
				return
			}
			//SOLO DIRECT
			this.callDirect().then(() => {
				console.debug('Chiamata diretta avviata')
			}).catch(e => {
				console.error('Impossibile usare la chiamata diretta', e)
				self.showError('Impossibile contattare in questo momento')
				self.navCtrl.pop()
			})
		} else {//SI VOIP
			//ID VOIP chiamato
			//2023 la notifica arriva basandosi su ID utente chiamato; quindi il peer ID è l'ID utente
			this.voipOtherId = this.housingUnit.intercom_user_id.toString()//ConfigProvider.generatePeerIdUser(this.housingUnit.intercom_user_id)
			console.debug('[HousingUnitIntercom.call()] Generato peer ID del chiamato: ' + this.voipOtherId, this.housingUnit)

			/* if(!this.housingUnit.intercom_phone) {//NO DIRECT
				this.callVoip()
			} else {//SI VOIP SI DIRECT li ha entrambi, usa VOIP se disponibile altrimenti GSM come backup */
			//Visualizza un loader mentre aspetta il timeout
			this.loading = this.loadingCtrl.create({
				content: 'Suonando...'
			})
			this.loading.present()

			/**
			Gestore del PONG: Se lo riceve (senza essere deregistrato), avvia la chiamata VOIP
			*/
			this.events.subscribe(DomainEvents.SERVER_SIGNALING_PONG, this.voipPongHandler)

			/*
			TIMEOUT al PING: Se non ha ricevuto PONG e quindi avviato VOIP, chiama vocale
			*/
			this.voipPingTimeout = setTimeout(self.voipPingTimeoutHandler, ConfigProvider.TIMEOUT_CALL_VOIP_PING * 1000)

			//Invia il PING
			this.signaling.sendPing(this.voipOtherId).then(ping => {
				console.debug('[HousingUnitIntercom.call().sendPing()] Inviato PING per verificare la connettività VOIP del chiamato: ' + ping)
			}).catch(e => {
				console.error('Impossibile inviare il messaggio di PING', e)
			})
			//}
		}
	}

	/**
	Esegue una chiamata diretta via SIM/GSM
	*/
	private callDirect(): Promise<boolean> {
		if(this.isCalling) {
			console.warn('Eseguita doppia richiesta di chiamata, ignoro la seconda')
			return Promise.reject('Chiamata già avviata, impossibile avviare una seconda chiamata')
		}
		this.isCalling = true
		let self = this

		//soft fail
               return new Promise((resolve, reject) => {
                       self.devices.call_native(this.housingUnit.intercom_phone).then(_ => {
                               self.isCalling = false
                               resolve(true)
                       }).catch(e => {
                               self.isCalling = false
                               reject(e)
                       })
               })
       }

	/**
	Visualizza la schermata di chiamata, avviandola

	Non controlla se c'è un timer o un'altra chiamata in corso, va fatto a monte da call().
	Non visualizza o nasconde eventuali loader
	*/
	private callVoip(): Promise<void> {
		console.debug('[HousingUnitIntercom.callVoip()] Inizializzazione chiamata VOIP')
		if(this.isCalling) {
			console.warn('Eseguita doppia richiesta di chiamata, ignoro la seconda')
			return Promise.resolve()
		}
		this.isCalling = true//blocca eventuali ulteriori accessi

		let self = this

		return this.navCtrl.push(CallPage, {
			otherId: this.voipOtherId,
			housingUnit: this.housingUnit,
			isVideoSent: this.voipIsVideo
		}).then(() => {//se condominio multiplo rimuove questa schermata dopo aver inserito l'altra
			if(!self.isSingleHousingUnit) {
				let index = this.viewCtrl.index
				self.navCtrl.remove(index)
			}
		}).catch(e => {
			console.error('Errore aprendo la pagina della videochiamata', e)
			self.isCalling = false
			//XXX eventualmente avvio la chiamata telefonica come backup o do un messaggio di errore?
		})
	}



	/**
	Se non è un citofono monoutenza imposta timeout per autochisura
	*/
	private checkAutoclose() {
		//se deve imposta un timeout di autochiusura
		if(!this.isSingleHousingUnit) {
			console.debug('[HousingUnitIntercomPage.checkAutoclose()] Citofono di condominio multiutente, chiusura automatica modale dopo 60 secondi')
			let self = this
			this.dismissTimeout = setTimeout(() => {
				self.dismissTimeout = null
				self.navCtrl.pop()
			}, 60000)
		}
	}


	/**
	Rimuove l'eventuale loader di chiamata
	*/
	private clearLoading() {
		if(this.loading) {
			this.loading.dismiss()
			this.loading = null
		}
	}

	/**
	Rimuove l'eventuale ping timer per telechiamata e pong listener per videochiamata.
	Dopo questa chiamata non eseguirà più nessuno dei due in automatico
	*/
	private clearPingPong() {
		if(this.voipPingTimeout) {
			clearTimeout(this.voipPingTimeout)
			this.voipPingTimeout = null
		}
		this.events.unsubscribe(DomainEvents.SERVER_SIGNALING_PONG, this.voipPongHandler)
	}

	/**
	Va in primo piano
	*/
	ionViewWillEnter() {
		//NOTE L'aggiornamento periodico del dispoisitivo è gestito a livello di DeviceProvider

		console.group('[HousingUnitIntercomPage.ionWillEnter()]')


		if(this.auth.isAuth) {
			console.log('Utente autenticato: Eseguo logout')
			this.auth.logout()
		}

		this.refresh()

		this.checkAutoclose()

		console.groupEnd()
	}

	ionViewDidEnter() {
		//NOTE i cambiamenti sino visibili solo dopo che è visualizzato, altrimenti producono eccezione
		this.isChangeDetected = true
	}

	ionViewWillLeave() {
		console.debug('[HousingUnitIntercomPage.ionViewDidLeave()]')
		this.isChangeDetected = false//ferma gli aggiornamenti grafici


		console.debug('[HousingUnitIntercomPage.ionViewDidLeave()] Rimuovo lo stato isCalling, rendendo disponibile per la prossima chiamata')
		this.isCalling = false

		//rimozione di interval e timeout
		if(this.dismissTimeout) {
			clearInterval(this.dismissTimeout)
		}

		//rimuove eventuale loader aperto
		this.clearLoading()

		//NOTE Non mettere giù la chiamata, perchè potrebbe essere sotto la pagina chiamata ed uscire dallo stack per timeout o altri motivi, mentre la chiamata è ancora in corso

		//De registra eventuale timer e listener
		this.clearPingPong()
	}

	/**
	Avvia la procedura di apertura portone previo login
	*/
	public open() {
               if(this.housingUnit.is_auto_open_enabled) {//apertura automatica abilitata
                       //2025 migrato ad DeviceProvider
                       this.devices.openDoor()
			let toast = this.toastCtrl.create({
				message: 'Apertura portone..',
				position: 'middle',
				cssClass: 'primary',
				duration: 3000
			})
			toast.present()
			return
		}

		//apertura previa autenticazione
		let self = this

		console.info('[Dashboard.open()] Login per apertura portone')
		this.navCtrl.push(LoginPage, {
			//isOneTime: true,
			isTypeForced: true,
			next: self.isSingleHousingUnit ? HousingUnitIntercomPage : CondominiumIntercomPage,
			nextNavParams: { housingUnit: self.housingUnit },
                       nextPush: false,//next diventa la root
                       nextCall: () => {
                               self.devices.openDoor()
                               let toast = self.toastCtrl.create({
                                       message: 'Apertura portone..',
                                       position: 'middle',
                                       cssClass: 'primary',
                                       duration: 3000
                               })
                               toast.present()
                       }
               })
       }

	private refresh() {
		let self = this

		this.isLoading = true
		this.isCalling = false

		if(self.housingUnit) {//impostata o già letta, la rilegge direttamente
			self.housingUnits.getById(self.housingUnit.id, ['condominium', 'condominium.devices', 'condominium.userRoles', 'userRoles']).then(housingUnit => {
				self.housingUnit = housingUnit
				self.isLoading = false
			}).catch(error => {
				console.error('Errore caricando i dati dell\'unità abitativa', error)
				let toast = self.toastCtrl.create({
					message: 'Errore caricando i dati dell\'unità abitativa',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
				self.isLoading = false
			})
		} else {//automatica, usa la prima del condominio del dispositivo
			console.info('[HousingUnitIntercomPage.refresh()] Nessuna unità abitativa assegnata, ne cerco una univoca')
			self.devices.getActual(['condominium', 'condominium.housingUnits', 'condominium.housingUnits.userRoles'], DeviceCache.FALLBACK).then(actualDevice => {
				if(!actualDevice) {
					console.error('[HousingUnitIntercomPage.refresh()] Dispositivo corrente non configurato, impossibile recuperare le unità immobiliari')
					self.showErrorRefreshing()
					self.isLoading = false
					return
				}

				if(!actualDevice.condominium_id || !actualDevice.condominium) {
					console.error('[HousingUnitIntercomPage.refresh()] Dispositivo corrente non associato a un condominio, impossibile recuperare le unità immobiliari')
					self.showErrorRefreshing()
					self.isLoading = false
					return
				}
				let housingUnits = actualDevice.condominium.housing_units

				if(!housingUnits || housingUnits.length == 0) {
					console.error('[HousingUnitIntercomPage.refresh()] Nessuna unità immobliare associata al condominio del dispositivo')
					self.showErrorRefreshing()
					self.isLoading = false
					return
				}

				if(housingUnits.length > 1) {
					console.error('[HousingUnitIntercomPage.refresh()] Più unità immobliari associate al condominio del dispositivo, doveva esserne specificata una esplicitamente')
				} else {
					this.isSingleHousingUnit = true
				}

				//assegna la prima unità
				self.housingUnit = housingUnits[0]
				self.isLoading = false
			}).catch(e => {
				console.error('Errore recuperando le unità immobiliari del condominio del dispositivo', e)
				self.showErrorRefreshing()
				self.isLoading = false
				return
			})
		}
	}

	private showError(message) {
		let toast = this.toastCtrl.create({
			message: message,
			position: 'middle',
			duration: 3000,
			cssClass: "danger"
		})
		toast.present()
	}

	private showErrorRefreshing() {
		this.showError('Errore caricando i dati dell\'unità abitativa')
	}

	public text() {
		let self = this

		this.navCtrl.push(MessageCreateIntercomPage, {
			housingUnit: this.housingUnit
		}).then(() => {
			if(!self.isSingleHousingUnit) {//se non è monoutenza rimuove questa schermata dopo aver inserito l'altra
				let index = self.viewCtrl.index
				self.navCtrl.remove(index)
			}
		})
	}
	public video() {
		return false
	}
}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-intercom/housing-unit-intercom.ts